export default __webpack_public_path__ + "assets/3343c62379daf8af6dbf30370ccb8d96.svg";